<template lang="pug">
    Select(:value="value" clearable :placeholder="$t('main.selectPlaceholder')" :not-found-text="$t('main.selectNotFoundText')" @on-clear="clearInput" @on-select="changeOption")
        Option(value="true") True
        Option(value="false") False
</template>
<script>
export default {
    props: ["formItem", "formData", "value"],
    methods: {
        changeOption(val) {
            this.$emit("input", val.value);
            this.formItem.watchField(val, this.formData);
        },
        clearInput() {
            this.$emit("input", "");
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/rcmTableFormItems/Boolean.vue